import type { Settings } from '@/types'
import { db } from './database'

export async function getSettings(): Promise<Settings> {
  const record = await db.settings.get('main')
  return record?.value || {
    installPromptShownAt: null,
    hasInstalled: false,
    dismissedToasts: [],
  }
}

export async function saveSettings(settings: Settings): Promise<void> {
  await db.settings.put({
    key: 'main',
    value: settings,
  })
}
